export class SellerImportModel {
    counter: number = 0;
    branchCode: number = 0;
    typeDocumentId: number = 0;
    documents: string = "";
    digitVerification: number = 0;
    name: string = "";
    position: string = "";
    phone: string = "";
    alterPhone: string | null = null;
    email: string = "";
    address: string = "";
    cityCode: string | null = null;
    departmentCode: string | null = null;
    observation: string = "";
    active: boolean = false;
    swExternal: boolean = false;

    constructor(counter: number,
        branchCode: number,
        typeDocumentId: number,
        documents: string,
        digitVerification: number,
        name: string,
        position: string,
        phone: string,
        alterPhone: string | null,
        email: string,
        address: string,
        cityCode: string | null,
        departmentCode: string | null,
        observation: string,
        active: boolean,
        swExternal: boolean,
    ) {
        this.counter = counter;
        this.branchCode = branchCode;
        this.typeDocumentId = typeDocumentId;
        this.documents = documents;
        this.digitVerification = digitVerification;
        this.name = name;
        this.position = position;
        this.phone = phone;
        this.alterPhone = alterPhone;
        this.email = email;
        this.address = address;
        this.cityCode = cityCode;
        this.departmentCode = departmentCode;
        this.observation = observation;
        this.active = active;
        this.swExternal = swExternal;
    }
}